export default {
      id: "ic_sportoto_popular-usage",
      viewBox: "0 0 16 16",
      url: "/" + "images/icons.3.109.2.svg#ic_sportoto_popular-usage",
      toString: function () {
        return this.url;
      }
    }